import { Client, HouseholdMember } from '../../../NavContextWrapper/types';

type UseHouseholdReturn = {
  getCircleColorForUser: (user: Client | HouseholdMember) => number;
  householdMembers: HouseholdMember[];
  householdMembersBesidesSelf: HouseholdMember[];
  canAddProfiles: boolean;
  showHouseholdSection: boolean;
};
export const useHousehold = (client: Client): UseHouseholdReturn => {
  const householdMembers = client.household?.members || [];
  const householdClientIds = householdMembers.map(member => member.id);

  // Return a consistent color code for a given client id, so the color stays with
  // the user when they switch family accounts.
  const getCircleColorForUser = (user: Client | HouseholdMember) => {
    const index = householdClientIds.indexOf(user.id);

    // If id is not found, it will be negative. Default to 0.
    return index >= 0 ? index : 0;
  };

  // Household members excluding the current client
  const householdMembersBesidesSelf = householdMembers.filter(
    member => member.id !== client.id,
  );

  // Can add profiles if completed onboarding and not a SHELL account
  const hasCompletedOnboarding = !client.capabilities.needsOnboarding;
  const canAddProfiles =
    hasCompletedOnboarding && client.businessLine !== 'SHELL';

  // Show household section if there are members to switch to or can add profiles
  const showHouseholdSection =
    householdMembersBesidesSelf.length > 0 || canAddProfiles;

  return {
    getCircleColorForUser,
    householdMembers,
    householdMembersBesidesSelf,
    canAddProfiles,
    showHouseholdSection,
  };
};
